import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsersService } from '../../services/users.service';
import { StorageService } from '../../services/storage.service';
import moment from "moment";

@Component({
    selector: 'app-verification-component',
    templateUrl: './verification.component.html',
    styleUrls: ['./verification.component.scss']
})
export class VerificationComponent implements OnInit, OnDestroy {
    private readonly codeTtlMs = 30 * 60 * 1000;
    private readonly maxAttempts = 5;
    private readonly lockDurationMs = 20 * 60 * 1000;

    codeInput = '';
    generatedCode = '';
    destinationRoute = '/';
    error = false;
    errorMessage = 'Invalid verification code.';
    loading = true;
    submitting = false;
    attemptsRemaining = this.maxAttempts;
    secondsUntilExpiry = 0;
    secondsUntilUnlock = 0;
    loginEmail = '';
    loginPassword = '';
    stateData: any = null;

    private expiresAtMs = 0;
    private lockedUntilMs = 0;
    private statusTimerId: number | null = null;

    copyright = "© " + moment().format('YYYY') + " saferoads.ph version 1.9 Powered by Reviewmasters Inc.";

    constructor(
        private userService: UsersService,
        private readonly storageService: StorageService,
        private readonly router: Router,
        private readonly cdr: ChangeDetectorRef
    ) {
        const loginState = this.router.getCurrentNavigation()?.extras?.state?.['login'] as {
            email?: string;
            password?: string;
        } | undefined;
        this.loginEmail = String(loginState?.email).trim();
        this.loginPassword = String(loginState?.password);

        //console.log('VerificationCode ngOnInit loginState:', loginState, 'loginEmail:', this.loginEmail, 'loginPassword:', this.loginPassword);
    }

    ngOnDestroy(): void {
        this.stopStatusTimer();
    }

    async ngOnInit(): Promise<void> {      
        //const token = await this.storageService.get('token');
        //if (!token) {
        //    await this.router.navigate(['/login']);
        //    return;
        //}

        const mfaVerified = await this.storageService.get('mfaVerified');
        if (mfaVerified === 'true') {
            //const userType = (await this.storageService.get('userType')) || '';
            //const defaultRoute = String(userType).toUpperCase() === 'DS-ADMIN' || String(userType).toUpperCase() === 'SCHOOL'
            //    ? '/v2/ds-admin'
            //    : '/v2/super-admin';
            //await this.router.navigate([defaultRoute]);
            return;
        }

        //const tempCode = await this.storageService.get('mfaTempCode');
        const tempRoute = await this.storageService.get('mfaTempRoute');
        const expiresAtRaw = await this.storageService.get('mfaCodeExpiresAt');
        const attemptsRaw = await this.storageService.get('mfaAttemptsRemaining');
        const lockedUntilRaw = await this.storageService.get('mfaLockedUntil');

/*         if (!tempCode) {
            await this.router.navigate(['/login']);
            return;
        } */

        //this.generatedCode = String(tempCode);
        this.destinationRoute = tempRoute ? String(tempRoute) : this.destinationRoute;
        this.expiresAtMs = this.parseEpoch(expiresAtRaw, Date.now() + this.codeTtlMs);
        this.attemptsRemaining = this.parseNumber(attemptsRaw, this.maxAttempts);
        this.lockedUntilMs = this.parseEpoch(lockedUntilRaw, 0);

        await this.storageService.set('mfaCodeExpiresAt', String(this.expiresAtMs));
        await this.storageService.set('mfaAttemptsRemaining', String(this.attemptsRemaining));

/*         const loginState = this.router.getCurrentNavigation()?.extras?.state?.['login'] as {
            email?: string;
            password?: string;
        } | undefined;

        this.loginEmail = String(loginState?.email).trim();
        this.loginPassword = String(loginState?.password); */



        if (!this.loginEmail || !this.loginPassword) {
            await this.router.navigate(['/login']);
            return;
        }

        //await this.storageService.set('mfaLoginEmail', this.loginEmail);
        //await this.storageService.set('mfaLoginPassword', this.loginPassword);

        this.startStatusTimer();
        this.refreshStatusState();
        this.loading = false;
        this.cdr.detectChanges();
    }

    async verifyCode(): Promise<void> {
        if (this.submitting || this.loading) {
            return;
        }

        this.refreshStatusState();
        if (this.isLocked()) {
            this.error = true;
            this.errorMessage = `Too many failed attempts. Try again in ${this.secondsUntilUnlock} seconds.`;
            return;
        }

        if (this.isCodeExpired()) {
            this.error = true;
            this.errorMessage = 'Code has expired. Please generate a new code.';
            return;
        }

        const normalized = this.codeInput.trim();
        if (!/^\d{7}$/.test(normalized)) {
            this.error = true;
            this.errorMessage = 'Please enter the 7-digit code.';
            return;
        }

        this.error = false;
        this.submitting = true;

        const login: { email?: string; password?: string } = {
            email: this.loginEmail,
            password: this.loginPassword,
        };

        const email = this.loginEmail;

        //console.log('verifyCode login:', login, 'codeInput:', this.codeInput, 'normalized:', normalized);

        let loginResponse: any;
        try {
            loginResponse = await this.userService.loginAuth(login, normalized);
        } catch (err: any) {
            //console.error('verifyCode loginAuth error:', err);
            loginResponse = {
                email: undefined,
                status: err?.status,
                error: err?.error ?? err,
            };
        }

        const response = loginResponse;

        //console.log('verifyCode response:', response);
        //console.log('verifyCode email:', email, response.email, 'error: ', response?.error?.statusCode);

        if (email !== response?.email || (response?.email == undefined || response?.status === 401)) {
            this.attemptsRemaining = Math.max(0, this.attemptsRemaining - 1);
            await this.storageService.set('mfaAttemptsRemaining', String(this.attemptsRemaining));

            if (this.attemptsRemaining <= 0) {
                this.lockedUntilMs = Date.now() + this.lockDurationMs;
                await this.storageService.set('mfaLockedUntil', String(this.lockedUntilMs));
                this.refreshStatusState();
                this.error = true;
                this.errorMessage = `Too many failed attempts. Try again in ${this.secondsUntilUnlock} seconds.`;
            } else {
                this.error = true;
                this.errorMessage = `Invalid verification code. ${this.attemptsRemaining} attempt(s) remaining.`;
                //console.log('Triggered error: Invalid verification code. Attempts remaining:', this.attemptsRemaining);
            }

            this.error = true;
            this.submitting = false;
            this.cdr.detectChanges();
            return;
        }

        await this.storageService.set('mfaVerified', 'true');
        await this.storageService.set('mfaTempCode', '');
        await this.storageService.set('mfaTempRoute', '');
        await this.storageService.set('mfaCodeExpiresAt', '');
        await this.storageService.set('mfaAttemptsRemaining', '');
        await this.storageService.set('mfaLockedUntil', '');
        //await this.storageService.set('mfaLoginEmail', '');
        //await this.storageService.set('mfaLoginPassword', '');
        this.stopStatusTimer();

        //console.log('User Type:', response?.userType);

        if (response?.userType === 'DS-ADMIN' || response?.userType === 'SCHOOL') {
            this.destinationRoute = '/admin';
        } else if (response?.userType === 'SUPER-ADMIN' || response?.userType === 'SUPER') {
            this.destinationRoute = '/school';  
        }
        //console.log('Navigating to destination route:', this.destinationRoute);
        
        await this.router.navigate([this.destinationRoute]);

        this.submitting = false;
        this.cdr.detectChanges();
    }

    navigateToLogin(): void {
        this.storageService.clear();
        void this.router.navigate(['/login']);
    }

    async regenerateCode(): Promise<void> {
        if (this.loading || this.submitting || this.isLocked()) {
            return;
        }

        this.generatedCode = this.generateSevenDigitCode();
        this.expiresAtMs = Date.now() + this.codeTtlMs;
        this.attemptsRemaining = this.maxAttempts;
        this.lockedUntilMs = 0;
        this.codeInput = '';
        this.error = false;
        this.errorMessage = '';

        await this.storageService.set('mfaTempCode', this.generatedCode);
        await this.storageService.set('mfaCodeExpiresAt', String(this.expiresAtMs));
        await this.storageService.set('mfaAttemptsRemaining', String(this.attemptsRemaining));
        await this.storageService.set('mfaLockedUntil', '');

        const login: { email?: string; password?: string } = {
            email: this.loginEmail,
            password: this.loginPassword,
        };

        const sendEmailTokenResponse = await this.userService.sendLoginAuth(login);

        this.refreshStatusState();
        this.cdr.detectChanges();
    }

    isCodeExpired(): boolean {
        return this.secondsUntilExpiry <= 0;
    }

    isLocked(): boolean {
        return this.secondsUntilUnlock > 0;
    }

    get secondsUntilExpiryMinutes(): number {
        return Math.ceil(this.secondsUntilExpiry / 60);
    }

    private refreshStatusState(): void {
        this.secondsUntilExpiry = this.computeRemainingSeconds(this.expiresAtMs);
        this.secondsUntilUnlock = this.computeRemainingSeconds(this.lockedUntilMs);

        if (this.secondsUntilUnlock === 0 && this.lockedUntilMs > 0) {
            this.lockedUntilMs = 0;
            this.attemptsRemaining = this.maxAttempts;
            void this.storageService.set('mfaLockedUntil', '');
            void this.storageService.set('mfaAttemptsRemaining', String(this.attemptsRemaining));
        }

        if (this.secondsUntilExpiry === 0 && !this.isLocked()) {
            this.error = true;
            this.errorMessage = 'Code has expired. Please generate a new code.';
        }
    }

    private computeRemainingSeconds(targetEpochMs: number): number {
        if (!targetEpochMs || targetEpochMs <= 0) {
            return 0;
        }

        const diffMs = targetEpochMs - Date.now();
        if (diffMs <= 0) {
            return 0;
        }

        return Math.ceil(diffMs / 1000);
    }

    private startStatusTimer(): void {
        this.stopStatusTimer();
        this.statusTimerId = window.setInterval(() => {
            this.refreshStatusState();
            this.cdr.detectChanges();
        }, 1000);
    }

    private stopStatusTimer(): void {
        if (this.statusTimerId != null) {
            window.clearInterval(this.statusTimerId);
            this.statusTimerId = null;
        }
    }

    private parseEpoch(value: string | null, fallback: number): number {
        const parsed = Number(value);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
    }

    private parseNumber(value: string | null, fallback: number): number {
        const parsed = Number(value);
        if (!Number.isFinite(parsed)) {
            return fallback;
        }

        return Math.max(0, Math.floor(parsed));
    }

    private generateSevenDigitCode(): string {
        return String(Math.floor(1000000 + Math.random() * 9000000));
    }
}
